export default __webpack_public_path__ + "static/media/three-horizontal-lines.1f59a530.svg";